/**
 * The alignment picked on a text that has no words yet. The editor stores it
 * on the empty block (`<h2 style="text-align: center;"></h2>`), and the
 * placeholder shown in its place has to sit there too.
 */
export const emptyBlockAlign = (doc: Document): string | null =>
  doc.body.querySelector<HTMLElement>('[style*="text-align"]')?.style
    .textAlign || null;
